/* eslint-disable react/jsx-no-target-blank */
import { Grid, Typography } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';

const App = () => {
  return (
    <Grid
      container
      direction={'row'}
      sx={{
        backgroundImage:
          'url(https://res.cloudinary.com/dwz5lx2k7/image/upload/v1681325953/zebra%20It/Image-01_jy0mtw.jpg)',
        height: '100vh',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        opacity: '0.7',
      }}
    >
      <Grid item xs={1} sm={1} md={2} lg={2} xl={2} />
      <Grid item xs={10} sm={10} md={8} lg={8} xl={8}>
        <Grid container direction={'column'}>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12} mt={4}>
            <img
              src='https://res.cloudinary.com/dwz5lx2k7/image/upload/v1681335858/zebra%20It/Zebra-IT-Logo_1_gcber1.jpg'
              alt='logo'
              height={80}
              width={80}
            />
          </Grid>
          <Grid
            item
            mt={{
              xs: 15,
              sm: 20,
              md: 25,
              lg: 30,
            }}
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
          >
            <Grid
              container
              direction={'column'}
              justifyContent={'center'}
              alignItems={'center'}
              spacing={1}
            >
              <Grid item>
                <Typography
                  align='center'
                  sx={{ color: '#000', fontWeight: 'bold' }}
                >
                  Our Website is coming soon, for
                </Typography>
              </Grid>
              <Grid item align='center'>
                <Typography
                  align='center'
                  sx={{ color: '#000', fontWeight: 600 }}
                >
                  more informaton
                </Typography>
              </Grid>
              <Grid item>
                <Typography
                  align='center'
                  sx={{ color: '#000', fontWeight: 400 }}
                >
                  Please see contacts Below
                </Typography>
              </Grid>
              <Grid item container direction={'row'} justifyContent={'center'}>
                <Grid item>
                  <EmailIcon />
                </Grid>
                <Grid item>
                  <Typography
                    align='center'
                    sx={{ color: '#000', fontWeight: 400 }}
                  >
                    <a
                      href='mailto:support@zebraitsolutions.com'
                      target='_blank'
                      style={{ textDecoration: 'none', color: '#000' }}
                    >
                      &nbsp; support@zebraitsolutions.com
                    </a>
                  </Typography>
                </Grid>
              </Grid>
              <Grid item container direction={'row'} justifyContent={'center'}>
                <Grid item>
                  <LocalPhoneIcon />
                </Grid>
                <Grid item>
                  <Typography
                    align='center'
                    sx={{ color: '#000', fontWeight: 400 }}
                  >
                    &nbsp; +243-833-726-375
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={1} sm={1} md={2} lg={2} xl={2} />
    </Grid>
  );
};
export default App;
